import React, { FunctionComponent } from 'react'
import { Button, ActionBar } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'

interface Props {
  onCancel: () => void
  onConfirm: () => void
  isSplitDisabled: boolean
}

export const LineItemSplitQuantityActionBar: FunctionComponent<Props> = ({
  onCancel,
  onConfirm,
  isSplitDisabled,
}) => (
  <ActionBar className="vd-flex--justify-end vd-pt3 vd-pb3">
    <div className="vd-btn-group">
      <Button
        variant="supplementary"
        onClick={onCancel}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            onCancel()
          }
        }}
        data-track="cancel-split-quantity"
        data-testid="cancel-split-quantity-button"
      >
        <T _str="Cancel" _context="Cancel split quantity button" />
      </Button>
      <Button
        variant="go"
        disabled={isSplitDisabled}
        onClick={onConfirm}
        onKeyDown={event => {
          if (
            (event.key === 'Enter' || event.key === ' ') &&
            !isSplitDisabled
          ) {
            event.preventDefault()
            onConfirm()
          }
        }}
        data-track="confirm-split-quantity"
        data-testid="confirm-split-quantity-button"
      >
        <T _str="Split" _context="Confirm split quantity button" />
      </Button>
    </div>
  </ActionBar>
)
